import Hospital from './Hospital';

export default Hospital;
